<template>
  <div class="contact-page">
    <!-- Banner -->
    <div class="page_banner">
      <img src="@/assets/images/page_cantact_banner.jpg">
      <h3><span>与华合一起建设化合物半导体产业的新生态</span></h3>
    </div>

    <!-- 联系方式 -->
    <div class="page_contact">
      <div class="page_contact_one">
        <h1>联系方式</h1>
        <h2>通过以下方式可以联系到我们</h2>
        <div class="contact_one">
          <h4><img src="@/assets/images/page_cantact_one_bj.jpg"></h4>
          <h3>
            <b><img src="@/assets/images/page_cantact_one_ino1.png"></b>
            <c></c>
            <f>电话：15995618715/025-52738939</f>
          </h3>
        </div>
        <div class="contact_two">
          <h4><img src="@/assets/images/page_cantact_one_bj.jpg"></h4>
          <h3>
            <b><img src="@/assets/images/page_cantact_one_ino2.png"></b>
            <c></c>
            <f>商务合作：eeyanjiang@163.com</f>
          </h3>
        </div>
        <div class="contact_three">
          <h4><img src="@/assets/images/page_cantact_one_bj.jpg"></h4>
          <h3>
            <b><img src="@/assets/images/page_cantact_one_ino4.png"></b>
            <c></c>
            <f>南京市浦口经济开发区秋韵路33号</f>
          </h3>
        </div>
      </div>

      <!-- 留言咨询 -->
      <div class="page_contact_two">
        <h1>留言咨询</h1>
        <h2>请将咨询内容写在栏中，按下"发送"键即可</h2>
      </div>

      <form method="POST" class="form2" enctype="multipart/form-data" action="https://huaheic.com/index.php?m=home&c=Lists&a=gbook_submit&lang=cn" @submit.prevent="submitForm">
        <div class="vali">
          <div id="p"><span>主题</span><font>选填</font></div>
          <input type="text" id="attr_1" name="attr_1" v-model="form.goodName">
        </div>
        <div class="vali reqtps">
          <div id="p"><span>姓名</span><font>必填</font></div>
          <input type="text" id="attr_2" name="attr_2" v-model="form.contacts" required>
        </div>
        <div class="vali reqtps">
          <div id="p"><span>地址</span><font>选填</font></div>
          <input type="text" id="attr_3" name="attr_3" v-model="form.remark">
        </div>
        <div class="vali">
          <div id="p"><span>手机号</span><font>必填</font></div>
          <input type="text" id="attr_4" name="attr_4" v-model="form.phoneNumber" required>
        </div>
        <div class="vali">
          <div id="p"><span>E-mail</span><font>选填</font></div>
          <input type="text" id="attr_5" name="attr_5" v-model="form.email">
        </div>
        <div class="vali1">
          <div id="p"><span>内容</span><font>选填</font></div>
          <textarea class="textarea_a" id="attr_6" name="attr_6" cols="45" rows="5" v-model="form.demand"></textarea>
        </div>
        <div class="submit">
          <input type="submit" class="btn" value="提交">
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  metaInfo: {
    title: '联系我们_商务合作_南京华合半导体科技有限公司',
    meta: [
      { name: 'description', content: '联系南京华合半导体科技有限公司，商务合作电话：15995618715/025-52738939，邮箱：eeyanjiang@163.com，地址：南京市浦口经济开发区秋韵路33号。欢迎咨询化合物半导体相关业务。' },
      { name: 'keywords', content: '联系华合半导体,商务合作,咨询电话,公司地址,化合物半导体咨询,南京半导体公司联系方式' },
      { name: 'robots', content: 'index,follow' },
      { property: 'og:title', content: '联系我们 - 南京华合半导体科技有限公司' },
      { property: 'og:url', content: 'https://huaheic.com/contact' }
    ],
    link: [
      { rel: 'canonical', href: 'https://huaheic.com/contact' }
    ]
  },
  data() {
    return {
      form: {
     
      }
    }
  },
  methods: {
    submitForm() {
      // 表单验证
      if (!this.form.contacts) {
        alert('姓名不能为空！')
        return false
      }
      if (!this.form.phoneNumber) {
        alert('手机号不能为空！')
        return false
      }
      // 提交表单
      this.$request.send('post', '/wx/sample/addSampleInfo', {
        goodName: this.form.goodName || '',
        contacts: this.form.contacts,
        phoneNumber: this.form.phoneNumber,
        email: this.form.email || '',
        demand: this.form.demand || '',
        remark: this.form.remark || ''
      }).then(response => {
        alert('提交成功！')
        // 清空表单
        this.form = {}
      }).catch(error => {
        alert('提交失败，请稍后重试')
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
.form2 #p font {
  /* display: inline-block; */
  width: 45px;
}

@media screen and (max-width: 740px) {
 
  .page_banner {
        height: 150px;
    }
    /* .page_banner h3 span {
      display: block;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      font-size: 14px;
              padding-top: 54px;

    } */
}
</style>
